import { useToast } from 'braid-design-system';
import { type FormEventHandler, useState } from 'react';
// TODO: Evaluate whether we want to keep using zod
import type { z } from 'zod';

import { signupNewsletter } from 'src/services/api';
import { createDotNetLinkUrl } from 'src/utils';
import { segmentIdentify } from 'src/utils/segment';

import { FormSchema } from './NewsletterSignUpForm.helpers';

export function useNewsletterSignUpFormState() {
  const showToast = useToast();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [formStatus, setFormStatus] = useState<
    | { kind: 'idle' }
    | { kind: 'loading' }
    | { kind: 'success' }
    | { kind: 'validation-error'; errors: z.ZodError<FormSchema> }
  >({ kind: 'idle' });

  const handleSubmit: FormEventHandler = async (event) => {
    event.preventDefault();

    if (formStatus.kind === 'loading') return;

    const parseResult = FormSchema.safeParse({
      FirstName: firstName,
      LastName: lastName,
      Email: email,
    });

    if (!parseResult.success) {
      setFormStatus({ kind: 'validation-error', errors: parseResult.error });
      return;
    }

    const formData = new FormData();
    for (const [key, value] of Object.entries(parseResult.data)) {
      formData.append(key, value);
    }

    setFormStatus({ kind: 'loading' });
    const result = await signupNewsletter(formData);

    segmentIdentify(email);

    if (result.kind === 'success') {
      setFormStatus({ kind: 'success' });
    } else {
      showToast({
        tone: 'critical',
        message:
          'There was an unexpected issue. Please try again or contact our support.',
        action: {
          label: 'Contact us',
          onClick: () =>
            window.location.assign(createDotNetLinkUrl('/contact-us')),
        },
        data: { testid: 'site-wide-footer-newsletter-signup-form-error-toast' },
      });
      setFormStatus({ kind: 'idle' });
    }
  };

  return {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    formStatus,
    handleSubmit,
  };
}
